const GREEKS = ['Delta', 'Gamma', 'Vega', 'Theta', 'Rho', 'Vanna', 'Volga'];
const GREEKS_SET = new Set(GREEKS);

/** Does a basic string check against a set of greek strings. Kinda of a heuristic to be used for rendering rather than logic */
export function isGreek(value: string): boolean {
  return GREEKS_SET.has(value);
}
